class MidiTrigger {
    constructor(stepData, time, stepNumber, outputNumber=0) {
        this.stepData = stepData;
        this.time = time;
        this.stepNumber = stepNumber;
        this.grabs = [];
        this.chokes = [];
        this.outputNumber = outputNumber;
    }
}

export default MidiTrigger;
